import React from 'react';
import { colors } from 'design-system';
import VectorIcon from './VectorIcon';
import IconProps from './IconProps';

const DataForPayment = ({
  width = 56,
  height = 56,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <circle
      cx="28"
      cy="28"
      r="26"
      fill="#0D2E68"
      stroke="url(#paint0_linear_11785:46980)"
      strokeWidth="4"
    />
    <path
      d="M15 20.75C15 19.8549 15.3556 18.9964 15.9885 18.3635C16.6214 17.7306 17.4799 17.375 18.375 
        17.375H38.625C39.5201 17.375 40.3785 17.7306 41.0115 18.3635C41.6444 18.9964 42 19.8549 42 
        20.75V29.1875H15V20.75ZM34.4062 22.4375C34.1825 22.4375 33.9679 22.5264 33.8096 22.6846C33.6514 
        22.8429 33.5625 23.0575 33.5625 23.2812V24.9688C33.5625 25.1925 33.6514 25.4071 33.8096 25.5654C33.9679 
        25.7236 34.1825 25.8125 34.4062 25.8125H37.7812C38.005 25.8125 38.2196 25.7236 38.3779 25.5654C38.5361 
        25.4071 38.625 25.1925 38.625 24.9688V23.2812C38.625 23.0575 38.5361 22.8429 38.3779 22.6846C38.2196 
        22.5264 38.005 22.4375 37.7812 22.4375H34.4062ZM15 32.5625V34.25C15 35.1451 15.3556 36.0035 15.9885 
        36.6365C16.6214 37.2694 17.4799 37.625 18.375 37.625H38.625C39.5201 37.625 40.3785 37.2694 41.0115 
        36.6365C41.6444 36.0035 42 35.1451 42 34.25V32.5625H15Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11785:46980"
        x1="28"
        y1="4"
        x2="28"
        y2="52"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={colors.bright_turquoise} />
        <stop offset="1" stopColor="#CEE8FF" />
      </linearGradient>
    </defs>
  </VectorIcon>
);

export default DataForPayment;
